export const SET_MODULES = "Set Modules";